// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import searchChallengesSelector from '../../redux/selectors/searchChallengesSelector';
import { actionCreatorsList } from '../../redux/rootActionCreator';
import { ProductCard } from '../../components/NewCard/types';
import { KeywordTitle } from '../../redux/actionCreators/search/searchChallengesKeywordActions';
import { SearchCondition } from '../../types/Model';

// 未來要改一下這個 Action，現在是用假 data 所以沒差
const {
  searchChallengesActions,
  searchChallengesKeywordActions
} = actionCreatorsList;

export function useSearchChallenges(limit: number, page: number, condition: SearchCondition): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(searchChallengesActions.request({
      limit,
      page,
      condition
    }));
  }, [page, condition])
}

export function useSearchChallengesKeywords(limit: number, name: string): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    if (name.length > 0) {
      dispatch(searchChallengesKeywordActions.request({
        limit,
        name
      }));
    }
  }, [limit, name])
}

export function useIsFetching(): boolean {
  return useSelector(searchChallengesSelector.makeIsFetching())
}

export function useChallengesList(): ProductCard[] {
  return useSelector(searchChallengesSelector.makeSearchChallenges());
}

export function useError(): Error | undefined {
  return useSelector(searchChallengesSelector.makeError());
}

export function useKeywords(keyword: string): KeywordTitle[] {
  return useSelector(searchChallengesSelector.makeSearchKeywordByKey(keyword));
}

export function useHasMoreResults(): boolean {
  return useSelector(searchChallengesSelector.makeHasMore());
}

export function useIsMoreFetching(): boolean {
  return useSelector(searchChallengesSelector.makeIsMoreFetching())
}

export function useCommonKeywords(keyword: string): KeywordTitle[] {
  return useSelector(searchChallengesSelector.makeSearchCommonKeywordByKey(keyword))
}
